import 'cropperjs/dist/cropper.css';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import RootApp from 'src/App';
import reportWebVitals from 'src/reportWebVitals';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <RootApp data-test-id="sales-portal-mfe-src-UnknownComponent-RootApp" />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
